<template>
  <div class="carousl_normal">
    <div
      class="uk-position-relative uk-visible-toggle"
      tabindex="-1"
      uk-slideshow="autoplay: true ;autoplay-interval: 6000;"
    >
      <ul class="uk-slideshow-items">
        <li
          class="slideshow-items web_pic_item"
          v-for="item in data"
          :key="item.pageId"
        >
          <a
            :href="item.content"
            style="display: block"
            class="a_link"
            title="[另開新視窗]國際趨勢文章"
            target="_blank"
          >
            <p
              class="phone_title"
              :style="{
                fontSize: fontSize.p + 'em',
                backgroundColor: bgc,
                margin: '5px 0',
              }"
            >
              {{ item.type }}
            </p>
            <img :src="item.image" alt="國際趨勢搭配圖片" />
            <p
              style="text-align: left; padding: 5px 10px"
              class="message text_content"
              :style="{ fontSize: fontSize.p + 'em' }"
            >
              {{ item.title }}
            </p>
          </a>
        </li>
      </ul>
      <a
        title="輪播左邊按鈕"
        class="uk-position-center-left uk-position-small"
        href="#"
        uk-slidenav-previous
        uk-slideshow-item="previous"
      >
        <span class="forFreeGo">&nbsp;</span>
      </a>
      <a
        title="輪播右邊按鈕"
        class="uk-position-center-right uk-position-small"
        href="#"
        uk-slidenav-next
        uk-slideshow-item="next"
      >
        <span class="forFreeGo">&nbsp;</span>
      </a>
    </div>
  </div>
</template>

<script setup>
import { inject } from "vue";

defineProps({
  data: {
    type: Array,
    required: true,
  },
  justify: {
    type: String,
    required: true,
  },
  bgc: {
    type: String,
    default() {
      return "";
    },
  },
});

let fontSize = inject("fontSize");
</script>

<style lang="scss" scoped>
.carousl_normal {
  margin: 0 10px;
  @media screen and (max-width: 960px) {
    margin: 0;
  }
}
img {
  object-fit: cover;
  width: 100%;
}
.a_link {
  aspect-ratio: 16 / 9;
  width: 100%;
  p {
    color: $black_color;
  }
}
.uk-position-relative {
  padding-bottom: 80px;
  @media screen and (max-width: 960px) {
    padding-bottom: 90px;
  }
  a {
    margin: 0;
    padding: 0;
    @media screen and (max-width: 960px) {
      margin: 15px 0;
      padding: 6px 3px;
    }
  }
  .pic {
    border-radius: 10px;
  }
  .phone_title {
    top: 7%;
    right: 4%;
    @media screen and (max-width: 960px) {
      top: 12%;
    }
  }
}
</style>
